import Vue from 'vue';
import focus from './focus';
import clickOutside from './click-outside';

Vue.directive('focus', focus);
Vue.directive('click-outside', clickOutside);
